
      import GoTo from './go-to.vue'
      import type { App, Plugin } from 'vue'

      export const GoToPlugin: Plugin = {
        install(app: App) {
          app.component('GoTo', GoTo)
        },
      }
      export { GoTo }
      